import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const AllUsers = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([
        // Sample data (replace with actual data)
        {
            name: 'John Doe',
            employeeId: 'EMP001',
            email: 'john.doe@example.com',
            date: '2025-01-01'
        },
        {
            name: 'Jane Smith',
            employeeId: 'EMP002',
            email: 'jane.smith@example.com',
            date: '2025-01-03'
        },
        {
            name: 'Alice Brown',
            employeeId: 'EMP003',
            email: 'alice.brown@example.com',
            date: '2025-01-05'
        },
    ]);
    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, employees]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDelete = (employeeId) => {
        const updatedEmployees = employees.filter(employee => employee.employeeId !== employeeId);
        setEmployees(updatedEmployees);
    };

    return (
        <>
            <h1 className="dashboard-title">All users</h1>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Employee Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Employee ID</th>
                            <th>Email</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((employee, index) => (
                                <tr key={index}>
                                    <td>{employee.name}</td>
                                    <td>{employee.employeeId}</td>
                                    <td>{employee.email}</td>
                                    <td>{employee.date}</td>
                                    <td>
                                        <button onClick={() => handleDelete(employee.employeeId)}>
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No users found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </>
    );
};

export default AllUsers;
